import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AsyncErrorHandler } from 'lib/ui';
import { CheckDuplicatePenPipeSize, PenPipeSizeDto } from 'models/pen/PenPipeSize';
import { PenPipeSizeService } from 'services/pen/pen-pipe-size-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class PenPipeSizeNew {
  private penPipeSize: PenPipeSizeDto = new PenPipeSizeDto();
  protected checkDuplicateData: CheckDuplicatePenPipeSize = new CheckDuplicatePenPipeSize();

  private constructor(
    private router: Router,
    private toastService: ToastService,
    private eventAggregator: EventAggregator,
    private penPipeSizeService: PenPipeSizeService
  ) {}

  @AsyncErrorHandler
  async createPenPipeSize() {
    if (await this.checkDuplicate()) return;

    this.penPipeSize.Name = this.penPipeSize.Size.toString();
    await this.penPipeSizeService.post(this.penPipeSize);
    this.eventAggregator.publish('penPipeSizesReset', 1);
    this.toastService.showSuccess('pens.penPipeSizeCreated');
    this.router.navigateToRoute('pen-pipe-size-list');
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.Size = this.penPipeSize.Size;
    const { IsDuplicate } = await this.penPipeSizeService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('penPipeSizeIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }
}
